import { Box, Icon, Text, Tooltip } from "@mbank-design/design-system/components";
import { ShieldTick, Tire, Gear, CreditCard, CarPhoneHandle, Car, Wrench } from "@mbank-design/design-system/icons";

export const CarTileServices = (props) => {

  const iconMap = {
    1: {icon:Wrench, hint:"pakiet Basic"},
    2: {icon:CreditCard, hint:"karta paliwowa"},
    3: {icon:Tire, hint:"pakiet opon"},
    4: {icon:CreditCard, hint:"karta paliwowa"},
    5: {icon:CarPhoneHandle, hint:"assistance"},
    6: {icon:ShieldTick, hint:"ubezpieczenie"},
    7: {icon:Wrench, hint:"pakiet Comfort"},
    8: {icon:Wrench, hint:"serwis Prestige"},
    9: {icon:Wrench, hint:"serwis Prestige"},
  };
  const basicServices = props.services
  const hasTwoPrestigePackages = props.services.includes(8) && props.services.includes(9);
  const filteredServices=  basicServices.filter((srv)=>srv !== 8)
  const serviceArr=  hasTwoPrestigePackages ? filteredServices : basicServices
  return (
    <Box display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-end"} gap={16}>
        <Text as={"p"} styledAs={["small","body"]}>usługi w racie</Text>
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={16}>
          {serviceArr.map((srv) => {
            return <Tooltip
            placement="top"
            hint={iconMap[srv].hint}
            icon={<Icon iconComponent={iconMap[srv].icon} primaryColor="funGreenUI" />}
            maxWidth={320}
            variant="mono_900"
          />;
          })}
        </Box>
    </Box>
  );
};
